import {t} from 'shared/core';

class GoogleMapsApi {
  static API_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY;

  static async geocode({address, lat, lng}) {
    const endpoint = new URL('https://maps.googleapis.com/maps/api/geocode/json');

    endpoint.searchParams.set('key', this.API_KEY);

    if (address) {
      endpoint.searchParams.set('address', address);
    } else {
      endpoint.searchParams.set('latlng', `${lat},${lng}`);
    }

    const res = await fetch(endpoint.toString());

    const data = await res.json();
    const {status, results} = data;

    switch (status) {
      case 'OK':
        return {results, error: null};
      case 'ZERO_RESULTS':
        return {results: [], error: t('components.google_location_picker.No results found.')};
      default:
        return {results: [], error: t('components.google_location_picker.Something went wrong, please try again.')};
    }
  }
}

export default GoogleMapsApi;
